var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-screen"},[_c('Header',{staticClass:"fixed w-full fixed z-50",attrs:{"selected":"preview"}}),_c('div',{staticClass:"pt-8"},[_c('div',{ref:"main",staticClass:"h-screen w-screen"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }